const { windowLoaded } = await import(`./modules/general.js?ver=${paths.cachebuster}`);
const { initMenu } = await import(`./modules/menu.js?ver=${paths.cachebuster}`);
const { initBuilder } = await import(`./modules/builder.js?ver=${paths.cachebuster}`);
const { initSlideshow } = await import(`./modules/slideshow.js?ver=${paths.cachebuster}`);

async function main() {
  await windowLoaded();

  try {
    //initLazyLoad(paths);
    initMenu();
    initBuilder();

    // Testimonials Slideshow
    if (document.querySelectorAll('section.chooseus .swiper')) {
      initSlideshow(document.querySelector('section.chooseus .swiper'));
    }
  } catch (err) {
    console.error(err);
  }
}

main();
